import { call, put, takeEvery } from "redux-saga/effects";

import {
  COMPRAS_LIST,
  COMPRAS_FULLLIST,
  COMPRAS_FILTER,
  COMPRAS_CREATE,
  COMPRAS_UPDATE,
} from "./actionTypes";

import {
  comprasListSuccess,
  comprasCreateSuccess,
  comprasUpdateSuccess,
  comprasRequestFailed,
  comprasFullListSuccess,
} from "./actions";

import {
  getComprasList,
  getComprasFilter,
  postComprasCreate,
  patchComprasUpdate,
  getComprasFullList,
} from "../../helpers/backend";

function* comprasListSaga() {
  console.log("Trayendo lista de compras...");
  try {
    const response = yield call(getComprasList);
    if (response.status === 200) {
      yield put(comprasListSuccess(response.data));
    } else {
      yield put(comprasRequestFailed(response.data));
    }
  } catch (error) {
    yield put(comprasRequestFailed(error.response.data));
  }
}
function* comprasFullListSaga() {
  console.log("Trayendo lista de compras de FullList...");
  try {
    const response = yield call(getComprasFullList);
    if (response.status === 200) {
      yield put(comprasFullListSuccess(response.data));
    } else {
      yield put(comprasRequestFailed(response.data));
    }
  } catch (error) {
    yield put(comprasRequestFailed(error.response.data));
  }
}

function* comprasCreateSaga({ payload: compras }) {
  console.log("Creando nuevo compras...");
  try {
    const response = yield call(postComprasCreate, compras);
    if (response.status === 201) {
      yield put(comprasCreateSuccess(response.data));
    } else {
      yield put(comprasRequestFailed(response.data));
      console.log(response.data);
    }
  } catch (error) {
    yield put(comprasRequestFailed(error.response.data));
  }
}

function* comprasFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getComprasFilter, { changeUrl });
    if (response.status === 200) {
      yield put(comprasListSuccess(response.data));
    } else {
      yield put(comprasRequestFailed(response.data));
    }
  } catch (error) {
    yield put(comprasRequestFailed(error.response.data));
  }
}

function* comprasUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos de la herramienta...");

  try {
    const response = yield call(patchComprasUpdate, id, data);
    if (response.status === 206) {
      yield put(comprasUpdateSuccess(response.data));
    } else {
      yield put(comprasRequestFailed(response.data));
      console.log(response.data);
    }
  } catch (error) {
    yield put(comprasRequestFailed(error.response.data));
  }
}

export default function* comprasSaga() {
  yield takeEvery(COMPRAS_LIST, comprasListSaga);
  yield takeEvery(COMPRAS_FULLLIST, comprasFullListSaga);

  yield takeEvery(COMPRAS_FILTER, comprasFilterSaga);
  yield takeEvery(COMPRAS_CREATE, comprasCreateSaga);

  yield takeEvery(COMPRAS_UPDATE, comprasUpdateSaga);
}
